import { render, staticRenderFns } from "./KscanSetting.vue?vue&type=template&id=3f452425"
import script from "./KscanSetting.vue?vue&type=script&lang=js"
export * from "./KscanSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports